<script>
export default {
  name: 'UlFormGenerator',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Boolean,
      default: true,
    },
    star: {
      type: Boolean,
      default: true,
    },
    module: {
      type: Object,
      required: true,
    },
    noLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    submit() {
      this.$refs.form.submit();
    },
  },
};
</script>
<template>
  <UlForm
    ref="form"
    :module="module"
    :loading="loading"
    :message="message"
    :noLoading="noLoading"
    :star="star"
    @submit="$emit('submit', $event)"
  >
    <UlFormItem
      v-for="item in module.items"
      :key="item.name"
      :module="item"
      @submit="submit"
    />
  </UlForm>
</template>
<style lang="scss">
</style>
